import { changePasswordApi } from './changePasswordApi';

export const { useChangePasswordMutation } = changePasswordApi;

export { changePasswordApi };
